module.exports = __webpack_public_path__ + "static/media/08_4.91340f19.png";